export default () => ({
    log: {},

    restaurant: {},

    morning: [],
    afternoon: []
})
